import React from 'react';
import { useFeatureToggle } from '~/platform/utilities/feature-toggles';
import { PROFILE_PATHS, PROFILE_PATH_NAMES } from '../constants';
import Tier2PageContent from './Tier2PageContent';
import { ProfileHubItem } from './hub/ProfileHubItem';

const AccountSecurity = () => {
  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
  const identityPasskeyEnabled = useToggleValue(
    TOGGLE_NAMES.identityPasskeyEnabled,
  );

  return (
    <Tier2PageContent
      pageHeader="Account security"
      pageTitle="Account Security"
    >
      <ProfileHubItem
        heading={PROFILE_PATH_NAMES.SIGNIN_INFORMATION}
        content="Manage your sign-in information and complete account setup."
        href={PROFILE_PATHS.SIGNIN_INFORMATION}
        reactLink
      />
      <ProfileHubItem
        heading={PROFILE_PATH_NAMES.CONNECTED_APPLICATIONS}
        content="Manage third-party apps that have access to your VA.gov profile."
        href={PROFILE_PATHS.CONNECTED_APPLICATIONS}
        reactLink
      />
      {identityPasskeyEnabled && (
        <ProfileHubItem
          heading={PROFILE_PATH_NAMES.PASSKEYS}
          content="Create and manage passkeys to sign in faster with your fingerprint, face, or device lock."
          href={PROFILE_PATHS.PASSKEYS}
          reactLink
        />
      )}
      <ProfileHubItem
        heading={PROFILE_PATH_NAMES.SIGNED_IN_DEVICES}
        content="Manage where you’re signed in to VA.gov."
        href={PROFILE_PATHS.SIGNED_IN_DEVICES}
        reactLink
      />
    </Tier2PageContent>
  );
};

AccountSecurity.propTypes = {};

export default AccountSecurity;
